export default "__VITE_ASSET__14c2a3a2__"